import { Component, OnInit } from "@angular/core";
import { version } from "../../../../../../../package.json";
@Component({
  selector: "kl-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  appVersion;
  constructor() {}

  ngOnInit(): void {
    this.appVersion = version;
  }
}
